import styled from "styled-components"

export const ModalTitle = styled.h2`
  font-size: 30px;
  line-height: 38px;
  color: ${(props) => props.theme.text.headline2};
  text-align: center;
  margin-bottom: 50px;
`
